<app-lms-modal-frame [title]="title" [pageHeadWidth]="350">
  <div modal-body>
    <div *ngIf="!showMessage" class="count-down-timer">
      <p>{{title}}</p>
      <div class="times">
        <p>{{ display }}</p>
      </div>
    </div>
    <div style="font-size: 14px;">
      <p><b *ngIf="showMessage">{{ message }}</b></p>
    </div>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary" mdbRipple (click)="onConfirm()">Continue</button>
  </div>
</app-lms-modal-frame>
